import { useContext } from 'react'
import { SubsidiaryDataContext } from '../HOCs/withAuth'

/**
 * useSubsidiaries - Returns an array of subsidiary values for API payload
 * @param {object} subsidiaryData - Data containing currentGlobalSubsidiary and all subsidiaries
 * @returns {Array} Array of subsidiary values
 */
function useSubsidiaries() {
    return useContext(SubsidiaryDataContext)
}

export default useSubsidiaries
